// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JTUjc{--icon-color: var(--white);position:fixed;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;z-index:200000}.JTUjc>.uTH9J{width:inherit;height:inherit;background-color:#000;opacity:.3;position:absolute}.SVXhz{position:absolute}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `300`,
	"popover": `550`,
	"nativeSafeAreaMask": `600`,
	"overlay": `uTH9J`,
	"portalledCalendar": `1500`,
	"inlinePicker": `100000`,
	"globalLoader": `JTUjc`,
	"nativeSplash": `200001`,
	"scoped": `SVXhz`
};
export default ___CSS_LOADER_EXPORT___;
